import React, { createRef } from "react";
import { Input, Select } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import Error from "../../../../Componets/Error";

const CreditNoteTable = React.forwardRef((props, focus) => {
  const { details, onDetailChange, onRemoveDetail, totals, readOnly } = props;

  const handleQuantityChange = (index, value) => {
    if (value >= 0) {
      const item = details[index];
      const maxQuantity = item.original_quantity || item.quantity;
      
      if (parseFloat(value) <= parseFloat(maxQuantity)) {
        onDetailChange(index, 'quantity', value);
      } else {
        // You can show a toast message here if needed
        onDetailChange(index, 'quantity', maxQuantity);
      }
    }
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-[100%]">
        <thead>
          <tr>
            <td className="border p-4 text-black">S.NO</td>
            <td className="border p-4 text-black">DESCRIPTION</td>
            <td className="border p-4 text-black">UNIT</td>
            <td className="border p-4 text-black">ORIGINAL QTY</td>
            <td className="border p-4 text-black">RETURN QTY</td>
            <td className="border p-4 text-black">PRICE</td>
            <td className="border p-4 text-black">TAX</td>
            <td className="border p-4 text-black">TOTAL</td>
            {!readOnly && <td className="border p-4 text-black">ACTION</td>}
          </tr>
        </thead>
        <tbody>
          {details?.map((value, index) => {
            focus.current[`quantity${index}`] = createRef();
            
            return (
              <tr key={index}>
                <td className="border p-4 text-center text-gray-700">
                  {index + 1}
                </td>
                <td className="border p-4">
                  <div className="w-[300px]">
                    <div className="text-sm text-gray-900">{value?.name}</div>
                    {value?.batch && (
                      <div className="text-xs">{`#BATCH-${value?.batch}`}</div>
                    )}
                    {value?.expiry_date && (
                      <div className="text-xs">
                        {`Expiry: ${new Date(value.expiry_date).toLocaleDateString()}`}
                      </div>
                    )}
                  </div>
                </td>
                <td className="border p-4 text-center">
                  {value?.unit_name || (value?.type === 'service' ? 'Service' : '')}
                </td>
                <td className="border p-4 text-center">
                  {parseFloat(value?.original_quantity || value?.quantity)?.toFixed(3)}
                </td>
                <td className="border p-4">
                  <Input
                    type="number"
                    className="w-full text-regular"
                    ref={focus.current[`quantity${index}`]}
                    placeholder="Return Quantity"
                    value={value?.quantity}
                    onChange={(e) => handleQuantityChange(index, e.target.value)}
                    autoComplete="off"
                    disabled={readOnly}
                    min="0"
                    max={value?.original_quantity || value?.quantity}
                  />
                  <Error id={`quantity${index}`} />
                </td>
                <td className="border p-4 text-center">
                  {parseFloat(value?.sale_price || 0)?.toFixed(3)}
                </td>
                <td className="border p-4 text-center">
                  {parseFloat(value?.tax_amount || 0)?.toFixed(3)}
                </td>
                <td className="border p-4 text-center">
                  {parseFloat(value?.total || 0)?.toFixed(3)}
                </td>
                {!readOnly && (
                  <td className="border p-4 text-center">
                    <button
                      type="button"
                      className="text-lg text-red-500 cursor-pointer hover:text-red-800"
                      onClick={() => onRemoveDetail(index)}
                    >
                      <DeleteOutlined />
                    </button>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td className="border p-4" colSpan={5}></td>
            <td className="border p-4 text-gray-700">SUBTOTAL</td>
            <td className="border p-4" colSpan={2}>
              {totals?.subtotal || "0.000"}
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={5}></td>
            <td className="border p-4 text-gray-700">TAX</td>
            <td className="border p-4" colSpan={2}>
              {totals?.taxamount || "0.000"}
            </td>
          </tr>
          <tr>
            <td className="border p-4" colSpan={5}></td>
            <td className="border p-4 text-black text-medium">TOTAL</td>
            <td className="border p-4 text-black text-medium" colSpan={2}>
              {totals?.total || "0.000"}
            </td>
          </tr>
        </tfoot>
      </table>
      
      {details?.length === 0 && (
        <div className="text-center p-8 text-gray-500">
          No items available. Please select an invoice to load items.
        </div>
      )}
    </div>
  );
});

export default CreditNoteTable;